/* La app de suscripciones se inyecta por JS y no se puede editar desde el tema.
   Le pegamos una linea de tranquilidad justo debajo de su bloque.
   Si algun dia se quita la app, esto no encuentra nada y no hace nada. */
(function () {
  var NOTE = 'La suscripción la pausas o cancelas cuando quieras, sin permanencia.';
  var tries = 0;

  /* Elemento mas profundo que hable de la suscripcion: evita agarrar el
     contenedor completo de la ficha, que fue lo que mandaba la nota al final. */
  function deepest() {
    var scope = document.querySelector('.product__info-container') || document.body;
    var all = scope.querySelectorAll('*');
    var best = null;
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.classList && el.classList.contains('mb-subnote')) continue;
      var t = (el.textContent || '').toLowerCase();
      if (t.indexOf('flight club') === -1 && t.indexOf('opciones de compra') === -1) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }

  /* Subimos hasta el envoltorio del widget, no mas. */
  function widget() {
    var node = deepest();
    if (!node) return null;
    var levels = 0;
    while (node.parentNode && levels < 8) {
      var t = (node.textContent || '').toLowerCase();
      if (t.indexOf('detalles de la suscrip') !== -1) return node;
      if (t.indexOf('flight club') !== -1 && t.indexOf('compra') !== -1 && levels >= 2) return node;
      node = node.parentNode;
      levels++;
    }
    return null;
  }

  function place() {
    tries++;
    var block = widget();
    if (!block || !block.parentNode) {
      if (tries < 14) setTimeout(place, 550);
      return;
    }

    var existing = document.querySelector('.mb-subnote');
    if (existing && existing.previousElementSibling === block) return;
    if (existing) existing.remove();

    var el = document.createElement('p');
    el.className = 'mb-subnote';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6.5 9.6 17 4 11.4"/></svg>' +
      '<span>' + NOTE + '</span>';
    block.parentNode.insertBefore(el, block.nextSibling);
  }

  document.addEventListener('DOMContentLoaded', place);
  document.addEventListener('shopify:section:load', function () { tries = 0; place(); });
  if (document.readyState !== 'loading') place();
  setTimeout(place, 900);
  setTimeout(place, 2200);
})();
